module.exports = __webpack_public_path__ + "img/green-before-clouds.12945e03.png";